import {useFormikContext} from 'formik'
import {TextField} from '@mui/material'
import {ItemCreationForm} from '../../../../../model/NewItemInput'
import {StepSection} from '../StepSection'
import {Label} from '../../../../../../genericComponents/typographie/Label'
import {AutoCompleteClassificationNode} from '../../../common/AutoCompleteClassificationNode'
import {ClassificationTypeEnum} from '../../../classificationNode/ClassificationNode'
import './SharedComponents.scss'
import { OrganizationSelect } from '../../../../../../organization/OrganizationSelect'

export const IdentificationSection = ({
                                          partNumberLabel = 'Part Number'
                                      }: {
    partNumberLabel?: string
}) => {
    const formik = useFormikContext<ItemCreationForm>()

    return (
        <StepSection title="Identification">
            <div className="service-form-field">
                <Label htmlFor="part-number" required>
                    {partNumberLabel}
                </Label>
                <TextField
                    data-testid="part-number"
                    required name="partNumber"
                    id="part-number"
                    placeholder="Input Part Number"
                    value={formik.values.partNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.partNumber && Boolean(formik.errors.partNumber)}
                    helperText={formik.touched.partNumber && formik.errors.partNumber as string}
                    inputProps={{'data-cy': 'partNumber-form'}}
                />
            </div>

            <div className="service-form-row">
                <div className="service-form-field">
                    <Label htmlFor="technicalClassification" required>
                        Technical Classification
                    </Label>
                    <AutoCompleteClassificationNode
                        classificationNodeIdToSearch={ClassificationTypeEnum.TECHNICAL}
                        formikClassificationNodeFieldName="technicalClassificationNode"/>
                </div>


                <div className="service-form-field">
                    <Label htmlFor="manufacturer" required>
                        Organization
                    </Label>
                    <OrganizationSelect
                        htmlId="manufacturer"
                        value={formik.values.definedByOrganization}
                        onBlur={() => formik.setFieldTouched('definedByOrganization', true)}
                        onChange={(value) => value && formik.setFieldValue('definedByOrganization', value)}
                        hasError={Boolean(formik.errors.definedByOrganization) && formik.touched.definedByOrganization}
                        testId={formik.values.definedByOrganization?.id}
                    />
                </div>
            </div>
        </StepSection>
    )
}